var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('header-guest'),_c('div',{staticClass:"alto"},[_vm._t("default")],2),_c('app-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }